const fetchCart = async () => {
    try {
      const res = await fetch('/cart.js');
      const data = await res.json();
      if (res.ok) return data;
    } catch (error) {
      console.log(error);
      return null
    }
}

const init = e => {
    console.log('Running custom scripts...');

    const debounce = (f, delay) => {
    let timer = 0;
        return function(...args) {
            clearTimeout(timer);
            timer = setTimeout(() => f.apply(this, args), delay);
        }
    }

    const sliderReinitCallback = ([entry]) => {
        const flkty = Flickity.data(entry.target);
        if (flkty) flkty.resize();
      }

    const moneyFormat = (amount) => {
        return `${ (amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }`;
    }

    const activateSlider = (elem, withRefresh, isProductgrid) => {
        const defaultSettings = {
            prevNextButtons: false,
            cellAlign: "left",
            groupCells: true
        }
        const { sliderSettings: customSettings } = elem.dataset;
        let flkty;
        if (customSettings)
            Object.assign(defaultSettings, JSON.parse(customSettings));

        flkty = new Flickity(elem, defaultSettings);
        if(withRefresh) {
            const reinitFlickitySlider = new ResizeObserver(debounce(sliderReinitCallback, 200));
            reinitFlickitySlider.observe(elem);
        }
        if(isProductgrid) {
            document.addEventListener('product-model-image-toggle', (e) => {
                let slideTarget = e.detail ? 1 : 0;
                flkty.select(slideTarget);
            });
        }
    }

    const sliders = document.querySelectorAll('.slider-enabled');
    if(sliders.length) {
        sliders.forEach(slider => {
            activateSlider(slider);
        })
    }

    const activateGridProductSliders = () => {
        const gridProductImages = document.querySelectorAll('.grid__images');

        if(gridProductImages.length) {
            gridProductImages.forEach(slider => {
                activateSlider(slider, false, true);
            })
        }
    }

    activateGridProductSliders();

    document.addEventListener("collection:reloaded", () => {
        activateGridProductSliders();
    });

    // Back to top button
    const backToTopBtn = document.querySelector('.js-back-to-top');
    if(backToTopBtn) {
        backToTopBtn.addEventListener('click', function() {
            window.scrollTo({top: 0, behavior: 'smooth'});
        })
    }

    // Reposition mega menu to fill gaps
    function resizeGridItem(item){
        let grid = document.querySelector(".megamenu .grid:first-child:not(.has-custom-mega-menu-image)");
        let rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
        let rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
        let rowSpan = Math.ceil((item.querySelector('.megamenu-content').offsetHeight+rowGap)/(rowHeight+rowGap));
        item.style.gridRowEnd = "span "+rowSpan;
    }
    
    function resizeAllGridItems(){
        let allItems = document.querySelectorAll(".megamenu .grid:first-child:not(.has-custom-mega-menu-image) .grid__item");
        for(let x=0;x<allItems.length;x++){
            resizeGridItem(allItems[x]);
        }
    }
    
    const megamenuItems = document.querySelectorAll('.site-nav--is-megamenu');
    if(megamenuItems.length) {
        megamenuItems.forEach(menu => {
            menu.addEventListener("mouseover", resizeAllGridItems);
        });
    }

    // Enable disclosure selector functionality on mobile menu
    const currencyEl = document.querySelector('.nav-drawer [data-disclosure-currency]');
    const localeEl = document.querySelector('.nav-drawer [data-disclosure-locale]');

    if(currencyEl) {
    new theme.Disclosure(currencyEl);
    }

    if(localeEl) {
    new theme.Disclosure(localeEl);
    }

    // Mobile menu slide
    const menuBtns = document.querySelectorAll('.js-open-next-menu');
    if(menuBtns.length) {
        menuBtns.forEach(btn => {
            btn.addEventListener('click', function(e) {
                e.target.closest('.mobile-slide-menu-parent.active')?.classList.remove('active');
                e.target.closest('.mobile-slide-menu-parent')?.classList.add('active');
            });
        });
    }
    const menuBackBtns = document.querySelectorAll('.js-back-to-prev-menu');
    if(menuBackBtns.length) {
        menuBackBtns.forEach(btn => {
            btn.addEventListener('click', function(e) {
                const parent = e.target.closest('.mobile-slide-menu-parent');
                if(parent) {
                    parent.closest('.mobile-slide-menu-parent:not(.active)')?.classList.add('active');
                    parent.classList.remove('active');
                }
            });
        })
    }

    // Tabbed collections show/hide
    const tabbedCollectionLink = document.querySelectorAll('.tabbed-collections__link');
    if(tabbedCollectionLink.length) {
        tabbedCollectionLink.forEach(tab => {
            tab.addEventListener('click', function(e) {
                e.preventDefault();
                const sectionContainer = e.target.closest('.tabbed-collections');
                const contentNum = e.target.getAttribute('data-collection');
                const activeTab = sectionContainer.querySelector('.tabbed-collections__link.active');
                const activeContent = sectionContainer.querySelector('.tabbed-collections__tabbed-content.active');
                const tabToDisplay = sectionContainer.querySelector(`.tabbed-collections__tabbed-content[data-collection="${contentNum}"]`);
                activeContent.classList.remove('active');
                activeTab.classList.remove('active');
                e.target.classList.add('active');
                tabToDisplay.classList.add('active');

                const sliders = tabToDisplay.querySelectorAll('.grid__images');
                sliders.forEach(slider => {
                    const oldFlickity = Flickity.data(slider);
                    oldFlickity.destroy();
                    const newFlickity = new Flickity(slider);
                })
            });
        })
    }

    // Free gift with purchase
    const initFreeGiftWithPurchase = async (product) => {
        if (!product) return;
        const tagPrefix = '_free-gift:';
        const taggedProducts = product.tags.find((tag) => tag.includes(tagPrefix));
        if (!taggedProducts.length) return;
        const headers = {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      
        const addFreeGift = async (firstVariantId, value) => {
            if (!firstVariantId) return;
        
            try {
                const res = await fetch(theme.routes.cartAdd, {
                    headers,
                    method: "POST",
                    body: JSON.stringify({
                        items: [{
                        id: +firstVariantId,
                        quantity: 1,
                        properties: {
                            "_free-gift": value
                        }
                        }]
                    })
                });
                if (res.ok) {
                    document.dispatchEvent(new CustomEvent('cart:build'));
                }
            } catch (error) {
                console.log({ error });
            }
        }
      
        const removeFreeGift = async (key) => {
            if (!key) return;
        
            try {
                const res = await fetch(theme.routes.cartChange, {
                    headers,
                    method: "POST",
                    body: JSON.stringify({
                        id: key,
                        quantity: 0
                    })
                });
                if (res.ok) {
                    document.dispatchEvent(new CustomEvent('cart:build'));
                }
            } catch (error) {
                console.log({ error });
            }
        }
      
        const checkCart = async (cart) => {
            if (!cart) return;
        
            const { items, total_price } = cart;
            const cartTotal = +moneyFormat(total_price / 100);
            if (!items.length) return;
            const productId = product.id;
            const firstVariantId = product.variants[0].id;
            const tag = taggedProducts;
            const value = tag ? +tag.replace(tagPrefix, '') : 0;
            const remaining = value - cartTotal;
            if (remaining <= 0) { // Free gift reached threshold
                const productInCart = items.find(({ product_id, variant_id, properties }) => {
                    return productId === product_id && properties['_free-gift']
                });
        
                if (!productInCart) {
                    addFreeGift(firstVariantId, value)
                }
        
            } else { // Free gift threshold not yet reached
                const productInCart = items.find(({ product_id, variant_id, properties }) => {
                    return productId === product_id && properties['_free-gift']
                });
        
                if (productInCart) {
                    removeFreeGift(productInCart.key);
                }
            }

        }
      
        try {
            const res = await fetch('/cart.js');
            const data = await res.json();
            if (res.ok) checkCart(data)
        } catch (error) {
            console.log({ error })
        }
      
        document.addEventListener('cart:updated', (evt) => {
            const { detail: { cart } } = evt;
            checkCart(cart);
        });
    }

    if (theme.settings.freeGiftProduct) {
        initFreeGiftWithPurchase(theme.settings.freeGiftProduct);
    }

    document.addEventListener('cart:ready', () => {
        const cartUpsellSlider = document.querySelector('.cart-upsell-slider__slider');
        if(cartUpsellSlider) {
            activateSlider(cartUpsellSlider, true);
        
            // Quick Add To Cart
            const cartUpsellVariantSelect = cartUpsellSlider.querySelectorAll('.variant-input-wrap select');
            if(cartUpsellVariantSelect.length) {
                cartUpsellVariantSelect.forEach(select => {
                    select.addEventListener('change', (e) => {
                        const parent = e.target.closest('.cart-upsell-slider__slide-content');
                        const priceElem = parent.querySelector('.price');
                        const selectedOptionName = e.target.value;
                        const selectedOption = parent.querySelector(`option[value="${selectedOptionName}"]`);
                        const price = moneyFormat(selectedOption.getAttribute('data-price') / 100);
                        const variantId = selectedOption.getAttribute('data-variant-id');
                        const atcBtn = parent.querySelector('.cart-upsell-slider__add-to-cart');
                        atcBtn.setAttribute('data-id', variantId);
                        priceElem.innerText = `$${price}`;
                    })
                })
            }
            const ATCBtns = document.querySelectorAll('.cart-upsell-slider__add-to-cart');
        
            const addUpsellToCart = (e) => {
                let id = e.target.getAttribute('data-id');
        
                let formData = {
                    'items': [{
                        'id': id,
                        'quantity': 1
                    }]
                };
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then(response => {
                    document.dispatchEvent(new CustomEvent('cart:build'));
                    return response.json();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            }
        
            for (let i = 0; i < ATCBtns.length; i++) {
                ATCBtns[i].addEventListener('click', (e) => {
                    e.preventDefault();
                    if (e.currentTarget.hasAttribute('disabled')) {
                    return;
                    }
                    addUpsellToCart(e);
                })
            }
        }

        // Remove undiscounted product
        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            let keys_to_remove = [];

            for (let i = 0; i < cart.items.length; i++) {
                if (cart.items[i].properties?.["_free-gift"] && cart.items[i].final_price > 0) {
                    keys_to_remove.push(cart.items[i].key)
                }
            }

            if (keys_to_remove.length > 0) {
                let updates = {};

                for (let i = 0; i < keys_to_remove.length; i++) {
                    updates[keys_to_remove[i]] = 0;
                }

                fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ updates })
                  })
                .then(response => {
                    document.dispatchEvent(new CustomEvent('cart:build'));
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            }
        }).catch((error) => {
            console.error('Error:', error);
        });
    });

    // Load more items - can be used for either blogs or collections
    class LoadMore extends HTMLElement {
        constructor(){
        super();
    
        this.action = this.dataset.action;
        this.baseUrl = this.dataset.url;
        this.totalPages = +this.dataset.totalPages;
        this.currentPage = +this.dataset.currentPage;
        this.gridTarget = document.querySelector(this.dataset.gridTarget);
        this.gridTargetClass = this.dataset.gridTarget;
        this.gridItemTargetClass = this.dataset.gridItemTarget;
        this.paginateOffset = parseInt(this.dataset.paginateOffset);
        this.numberOfPromos = parseInt(this.dataset.numberOfPromos);

        if(this.paginateOffset > 0) {
            this.hideOffsetItems(true);
        }
    
        this.renderBtn();
        }
    
        renderBtn() {
        let showBtn = false;
    
        if(this.action === "next" && this.totalPages > this.currentPage) {
            showBtn = true;
        }
    
        if(this.action === "previous" && this.currentPage !== 1) {
            showBtn = true;
        }
    
        if(showBtn) {
            let btnHtml = `
            <div class="load-more-wrap text-center">
                <button type="button" class="btn">Load ${this.action === "next" ? "More" : "Previous"}</button>
            </div>
            `;
            this.innerHTML = btnHtml;
            this.registerBtnEvtListener();
        }
        }
    
        registerBtnEvtListener() {
        const btn = this.querySelector('.btn');
        btn.addEventListener('click', (e) => {
            this.fetchItems(e.target);
        })
        }
    
        getCurrentUrl() {
        let queryString = window.location.search;
    
        if(queryString) {
            const urlParams = new URLSearchParams(queryString);
            if(urlParams.has('page')) {
            queryString = queryString.replace(`page=${urlParams.get('page')}`, '[page]');
            }
            return this.baseUrl + queryString;
            
        } else {
            return this.baseUrl;
        }
        }
    
        async fetchItems(btn) {
        btn.classList.add('btn--loading');
    
        let currentUrl = this.getCurrentUrl();
        let newPage = this.currentPage;
    
        if(this.action === "next") {
            newPage = this.currentPage + 1;
        }
    
        if(this.action === "previous") {
            newPage = this.currentPage - 1;
        }
    
        if(currentUrl.includes('[page]')) {
            currentUrl = currentUrl.replace('[page]', 'page=' + newPage);
        } else if(currentUrl.includes('?')) {
            currentUrl = currentUrl +'&page='+newPage;
        } else {
            currentUrl = currentUrl +'?page='+newPage;
        }
    
        try {
            const res = await fetch(currentUrl);
            const text = await res.text();
    
            if (res.ok) {
            this.renderItems(text);
            }
        } catch (error) {
            console.log(error);
        } finally {
            if((this.action === "next" && newPage >= this.totalPages) || (this.action === "previous" && newPage <= 1)) {
                this.reshowHiddenOffsetItems();
                btn.remove();
            } else {
                btn.classList.remove('btn--loading');
                if(this.paginateOffset > 0) {
                    this.reshowHiddenOffsetItems();
                    this.hideOffsetItems();
                }

                activateGridProductSliders();
            }
            const productModelImageToggle = document.querySelector('#product-model-image-toggle-input');
            if(productModelImageToggle) {
                if(productModelImageToggle.checked) {
                    document.dispatchEvent(new CustomEvent('product-model-image-toggle', {detail: true}));
                } else {
                    document.dispatchEvent(new CustomEvent('product-model-image-toggle', {detail: false}));
                }
            }

            theme.initQuickShop();
            this.updatePageCount(newPage);
            window.history.pushState({page: newPage}, "", currentUrl);
        }
        }

        reshowHiddenOffsetItems() {
            const alreadyHidden = document.querySelectorAll(`${this.gridTargetClass} ${this.gridItemTargetClass}.hide`);
            if(alreadyHidden.length) {
                alreadyHidden.forEach(item => {
                    item.classList.remove('hide');
                    const gridProductImages = item.querySelectorAll('.grid__images');
                    if(gridProductImages.length) {
                        setTimeout((e) => {
                            gridProductImages.forEach(slider => {
                                const oldFlickity = Flickity.data(slider);
                                oldFlickity.destroy();
                                activateSlider(slider);
                            })
                        },500);
                    }
                })
            }
        }

        hideOffsetItems(initial) {
            let itemsToHide = document.querySelectorAll(`${this.gridTargetClass} ${this.gridItemTargetClass}:nth-last-child(-n+${this.paginateOffset})`);
            if(initial) {
                const numberToOffset = this.paginateOffset + this.numberOfPromos;
                itemsToHide = document.querySelectorAll(`${this.gridTargetClass} ${this.gridItemTargetClass}:nth-last-child(-n+${numberToOffset})`);
            }
            
            if(itemsToHide.length) {
                itemsToHide.forEach(item => {
                    item.classList.add('hide');
                })
            }
        }
    
        updatePageCount(newPage) {
        this.currentPage = newPage;
        this.setAttribute('data-current-page', newPage);
        }
    
        parseProductHTML(text) {
        const html = document.createElement('div');
        html.innerHTML = text;
    
        return {
            items: html.querySelectorAll(`${this.gridTargetClass} ${this.gridItemTargetClass}`)
        }
        }
    
        renderItems(text) {
        const markup = this.parseProductHTML(text);
        if(this.action === "next") {
            this.gridTarget.append(...markup.items);
        }
        if(this.action === "previous") {
            this.gridTarget.prepend(...markup.items);
        }
        
        if (window.AOS) { AOS.refreshHard() }
        document.dispatchEvent(new CustomEvent('collection:reloaded'));
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
        }
    }
    
    if (!customElements.get('load-more')) {
        customElements.define('load-more', LoadMore);
    }

    // Product social share hide/show
    const socialShareBtn = document.querySelector('.js-show-social-share');
    if(socialShareBtn) {
        socialShareBtn.addEventListener('click', function(e) {
            const socialShareDiv = e.target.querySelector('.social-share-product');
            socialShareDiv.classList.toggle('hide');
            e.target.classList.toggle('btn');
        })
    }

    // Product style with mouse drag
    function clickAndDrag(selector, scroll_speed = 3, classOnEvent = 'grabbed_elem') {
        const slider = document.querySelector(selector);
        let isDown = false;
        let startX;
        let scrollLeft;
    
        slider.addEventListener('mousedown', (e) => {
            e.preventDefault();
            isDown = true;
            slider.classList.add(classOnEvent);
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove(classOnEvent);
        });
        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove(classOnEvent);
        });
        slider.addEventListener('mousemove', (e) => {
            if(!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * scroll_speed; //scroll-fast
            slider.scrollLeft = scrollLeft - walk;
        });
    }
    
    const mouseClickDragEl = document.querySelector('.js-mouse-click-drag');
    if(mouseClickDragEl) {
        clickAndDrag('.js-mouse-click-drag');
    }

    // START ALSO AVAILABLE IN
    theme.GraphQL = {

        config:  {
            storefront_token: '0db971b13d2dcbbd906bc192c958f7b5',
            request_url: theme.routes.storefrontAPI
        },
    
        sendRequest: function(request, request_group, output_container) {
    
            if(this.config[request_group] == null) {
                this.config[request_group] = 1;
            } else {
                this.config[request_group]++;
            }
    
            let return_response = null;
    
            let settings = {
                'crossDomain': true,
                'url': this.config.request_url,
                'method': 'POST',
                'headers': {
                    'X-Shopify-Storefront-Access-Token': this.config.storefront_token,
                    'Content-Type': 'application/graphql',
                },
                'data': request,
                'success': function(response) {
                    theme.GraphQL.config[request_group]--;
                    return_response = response;
                },
                'error': function(xhr, errDesc) {
                    theme.GraphQL.config[request_group]--;
                    console.log(errDesc);
                }
            };
            $.ajax(settings)
                .done(function() {
                    if(request_group === "also-available") {
                        theme.AlsoAvailableIn.buildOutput(return_response);
                    }
                    theme.GraphQL.cleanUp(request_group);
                });
        },
    
        cleanUp: function(request_group) {
            if(theme.GraphQL.config[request_group] < 1) {
                $('body').trigger(request_group+":loaded");
                delete this.config[request_group];
            }
        }
    };
    
    theme.AlsoAvailableIn = (function() {
    let config = {
        request_query: '',
        current_product: '',
        product_name: '',
    };

    let swatch_html = `
    <a class="###swatchCurrent###" href="###productURL###" title="###swatchColour###"><span style="background-color: ###finalColor###; background-image: url(###colorImage###);"></span></a>
    `;

    function init(container) {
        let $container = this.$container = $(container);
        config.request_query = $container.data('request-query');
        config.current_product = $container.data('current-product');
        config.product_name = $container.data('product-name');

        let request_query = `
            {
            products(first: 100, query: "title:`+config.request_query+`*") {
                edges {
                node {
                    onlineStoreUrl
                    availableForSale
                    title
                    handle
                }
                }
            }
            }
        `;

        try {
            theme.GraphQL.sendRequest(request_query, "also-available");
        }
        catch(err) {
            console.error("Errors in GraphQL: "+err);
        }

    }

    function buildOutput(response) {
        let output_html = '';
        let product_arr = response.data.products.edges;
        let show_items = 0;
        if(product_arr.length <= 1) {
            return;
        }

        for (let i=0;i<product_arr.length;i++) {
            let product_title = product_arr[i].node.title.split(" - ");

            if (!product_arr[i].node.availableForSale) {
                continue;
            }

            let thisTitle = product_arr[i].node.title.split(' - ')[0].trim();
            if (thisTitle !== this.$container.data('request-query')) {
                continue;
            }
            show_items++;
            let color = product_title[1];
            let colorLC = color.toString().toLowerCase();
            let colorLCSplit = colorLC.split(' ');
            let finalColor = colorLCSplit.slice(-1);
            let customClass = '';

            if ( colorLC == 'white gold' ) {
                finalColor = 'white';
            }

            if(product_arr[i].node.handle === config.current_product) {
                customClass = 'active'
            }

            let colorValueSlugify = colorLC.replaceAll(' ', '-');
            let colorImage = theme.settings.file_url.replace('/?', '/' + colorValueSlugify + '_50x.png?');

            let output = swatch_html;
            let productURL = product_arr[i].node.onlineStoreUrl;
            if(productURL === null) {
                productURL = '/products/' + product_arr[i].node.handle;
            }
            output = output.replace("###productURL###",productURL);
            output = output.replace("###swatchCurrent###",customClass);
            output = output.replace('###swatchColour###', color);
            output = output.replace('###finalColor###', finalColor);
            output = output.replace('###colorImage###', colorImage);
            output_html += output;
            
        }

        if(show_items > 1) {
            this.$container.show();
        }

        const containerEl = this.$container.find('.aa-container');
        containerEl.innerHTML = '';
        containerEl.append(output_html);

        document.dispatchEvent(new CustomEvent('alsoAvailable:loaded'));
    }

    return {
        init: init,
        buildOutput: buildOutput
    };

    })();

    const alsoAvailableElem = document.querySelector('[data-section-type="also-available"]');
    if(alsoAvailableElem) {
        theme.AlsoAvailableIn.init(alsoAvailableElem);
    }

    // END ALSO AVAILABLE IN

    const aaiColorSelect = document.querySelector('.js-aai-choose-color');
    if(aaiColorSelect) {
        aaiColorSelect.addEventListener('change', function() {
            window.location = this.value;
        });
    }

    // Copy text to clipboard
    const copyToClipboardBtns = document.querySelectorAll('.js-copy-to-clipboard');
    if(copyToClipboardBtns.length > 0) {
        copyToClipboardBtns.forEach(btn => {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                const text = e.target.getAttribute('data-text');
                navigator.clipboard.writeText(text);
                const notificationEl = e.target.parentNode.querySelector('.text-copied-alert');
                notificationEl.classList.remove('hide');
                setTimeout(function() {
                    notificationEl.classList.add('hide');
                },3000);
            });
        })
    }

    // Custom Swatch base on product title
    async function swatchByProduct(current,baseTitle,fullTitle) {
        const url = theme.routes.storefrontAPI
        const accessToken = '0db971b13d2dcbbd906bc192c958f7b5';
        // const searchTerm = elem.dataset.searchTerm;

        let query = `{
        predictiveSearch(query: "${baseTitle}") {
            products {
                title
                handle
                id
                variants(first: 1) {
                    nodes {
                        id
                    }
                }
                compareAtPriceRange {
                    maxVariantPrice {
                        amount
                    }
                    minVariantPrice {
                        amount
                    }
                }
                priceRange {
                    maxVariantPrice {
                      amount
                    }
                    minVariantPrice {
                      amount
                    }
                }
                images(first: 2) {
                    edges {
                        node {
                            url
                        }
                    }
                }
            }
        }
        }`;

        try {
        const res = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/graphql",
                "X-Shopify-Storefront-Access-Token": accessToken
            },
            body: query
        });
        const data = await res.json();

        if (res.ok) {

            let swatches = '';

            // 0 display even 1 swatch
            // 1 display only more than 1 swatch
            
            if ( data.data.predictiveSearch.products.length > 0 ) {
            data.data.predictiveSearch.products.forEach(swatch => {
                let swatchTitleSplit = swatch.title.split(' - ');
                let swatchBaseTitle = swatchTitleSplit[0];

                let color = swatchTitleSplit.slice(-1);
                let colorLC = color.toString().toLowerCase();
                let colorLCSplit = colorLC.split(' ');
                let finalColor = colorLCSplit.slice(-1);
                let customClass = '';
                let productId = swatch.id.split('/').slice(-1);
                let variantId = swatch.variants.nodes[0].id.split('/').slice(-1);

                if ( colorLC == 'white gold' ) {
                finalColor = 'white';
                }

                if ( swatch.title == fullTitle ) {
                customClass = 'active'
                }

                let colorValueSlugify = colorLC.replaceAll(' ', '-');
                let colorImage = theme.settings.file_url.replace('/?', '/' + colorValueSlugify + '_50x.png?');

                // Display only within base title
                if ( swatchBaseTitle == baseTitle ) {
                swatches += `
                    <li class="${customClass}">
                    <button type="button"
                    class="custom-swatch-btn"
                    data-color="${colorLC}"
                    data-handle="${swatch.handle}"
                    data-image-one="${swatch.images.edges[0].node.url}"
                    data-image-two="${swatch.images.edges[1] ? swatch.images.edges[1].node.url : ''}"
                    data-title="${swatch.title}"
                    data-maxprice="${swatch.priceRange.maxVariantPrice.amount}"
                    data-minprice="${swatch.priceRange.minVariantPrice.amount}"
                    data-compare-maxprice="${swatch.compareAtPriceRange.maxVariantPrice.amount}"
                    data-compare-minprice="${swatch.compareAtPriceRange.minVariantPrice.amount}"
                    data-url="/products/${swatch.handle}"
                    data-product-id="${productId}"
                    data-variant-id="${variantId}"
                    style="background-color: ${finalColor}; background-image: url(${colorImage});">
                    </button>
                    </li>`;
                }
            });

            let swatchLink = `<ul class="custom-swatch">${swatches}</ul>`;

            current.querySelector('[data-custom-swatches]').innerHTML = swatchLink;
            }
        } else {
            console.log('None');
        }
        }
        catch (err) {
        console.error(err);
        }
    }

    // Custom Swatch base on product title
    const checkSwatches = () => {
        let titles = document.querySelectorAll('.product-grid .grid__item .grid-product__title');
        
        if ( titles.length > 0 ) {
            titles.forEach(title => {
                let titleSplit = title.innerHTML.split(' - ');
                let baseTitle = titleSplit[0];
                let fullTitle = title.innerHTML;

                const current = title.closest('.grid__item');

                if ( titleSplit.length > 1 && !current.querySelector('.custom-swatch') ) {
                swatchByProduct(current,baseTitle,fullTitle);
                }
            })
        }
    }

    checkSwatches();
    document.addEventListener('collection:reloaded', function() {
        checkSwatches();
    });

    const customformSelect = document.querySelector('.js-custom-form-select');
    if(customformSelect) {
        customformSelect.addEventListener('change', (e) => {
            const target = e.target.value;
            document.querySelector('.custom-form-block.active').classList.remove('active');
            document.querySelector(`.custom-form-block[data-form-id="${target}"]`).classList.add('active');
        });
    }

    const productModelImageToggle = document.querySelector('#product-model-image-toggle-input');
    if(productModelImageToggle) {
        productModelImageToggle.addEventListener('change', (e) => {
            document.dispatchEvent(new CustomEvent('product-model-image-toggle', {detail: e.target.checked}));
        });
    }
}

document.addEventListener('DOMContentLoaded', init, false);


document.addEventListener('click', async function(event) {
    if (event.target.classList.contains('custom-swatch-btn') ) {        
        let current = event.target;
        let currentGrid = current.closest('.grid-product');

        if ( currentGrid ) {
            currentGrid.querySelector('a.grid-product__link').setAttribute('href', current.dataset.url);
            currentGrid.querySelector('.grid-product__meta a.grid-product__link').setAttribute('href', current.dataset.url);
            currentGrid.querySelector('.grid-product__title').innerText = current.dataset.title;
            const hasSlider = currentGrid.querySelector('.flickity-slider');

            if ( current.dataset.imageOne && !current.dataset.imageTwo ) {
                currentGrid.querySelector('.grid-product__image-mask .grid__image-ratio img').setAttribute('src', current.dataset.imageOne);
                currentGrid.querySelector('.grid-product__image-mask .grid__image-ratio img').setAttribute('srcset', '');
            } else if ( current.dataset.imageOne && current.dataset.imageTwo && hasSlider) {
                const sliderImages = hasSlider.querySelectorAll('.grid-product__image-mask .grid__image-ratio img');
                if(theme.settings.productModelImageToggleDefaultView == 'Model') {
                    sliderImages[0].setAttribute('src', current.dataset.imageTwo);
                    sliderImages[0].setAttribute('srcset', '');
                    sliderImages[1].setAttribute('src', current.dataset.imageOne);
                    sliderImages[1].setAttribute('srcset', '');
                } else {
                    sliderImages[0].setAttribute('src', current.dataset.imageOne);
                    sliderImages[0].setAttribute('srcset', '');
                    sliderImages[1].setAttribute('src', current.dataset.imageTwo);
                    sliderImages[1].setAttribute('srcset', '');
                }
            }

            let priceHtml = '';
            let compareAtPriceMin = current.dataset.compareMinprice;
            let minPrice = current.dataset.minprice;
            let maxPrice = current.dataset.maxprice;
            let productId = current.dataset.productId;
            let currentProductId = currentGrid.dataset.productId;
            let productHandle = current.dataset.handle;
            let quickShopModal = document.querySelector(`#QuickShopModal-${productId}`);
            if(!quickShopModal) {
                quickShopModal = document.querySelector(`#QuickShopModal-${currentProductId}`);
                if(quickShopModal) {
                    quickShopModal.setAttribute('id', `QuickShopModal-${productId}`);
                    quickShopModal.setAttribute('data-product-id', productId);
                    let quickShopInner = quickShopModal.querySelector('div[id^="QuickShopHolder-"]');
                    quickShopInner.setAttribute('id', `QuickShopHolder-${productHandle}`);
                }
            }

            if(quickShopModal) {
                let quickShopBtn = currentGrid.querySelector(`.js-modal-open-quick-modal-${currentProductId}`);
                if(quickShopBtn) {
                    quickShopBtn.classList.remove(`js-modal-open-quick-modal-${currentProductId}`);
                    quickShopBtn.classList.add(`js-modal-open-quick-modal-${productId}`);
                }
                theme.initQuickShop();
            }
            currentGrid.setAttribute('data-product-id', productId);
            currentGrid.setAttribute('data-product-handle', productHandle);

            let wishlistBtn = currentGrid.querySelector('.swym-button');
            if(wishlistBtn) {
                let variantId = current.dataset.variantId;
                let wishlistProductId = wishlistBtn.dataset.productId;
                wishlistBtn.classList.remove(`product_${wishlistProductId}`);
                wishlistBtn.classList.add(`product_${productId}`);
                wishlistBtn.setAttribute('data-product-id', productId);
                wishlistBtn.setAttribute('data-variant-id', variantId);
                wishlistBtn.setAttribute('data-product-url', `${window.location.origin}/products/${productHandle}`);
                let wishlistId = 'wishlist-' + productId + Date.now();
                currentGrid.setAttribute("id", wishlistId);
                document.dispatchEvent(new CustomEvent("swatch-wishlist-update", {detail: wishlistId}));
            }

            if(Shopify.currency.active != theme.settings.defaultCurrency) {
                const url = current.dataset.url + '.json';
                const accessToken = '0db971b13d2dcbbd906bc192c958f7b5';
                try {
                    const res = await fetch(url, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/graphql",
                            "X-Shopify-Storefront-Access-Token": accessToken
                        }
                    });
                    const data = await res.json();
            
                    if (res.ok) {
                        const variants = data.product.variants;
                        let prices = variants.map(variant => variant.price);
                        prices = prices.slice() // slice makes copy of array before sorting it
                            .sort(function(a,b){
                                return parseInt(a) > parseInt(b);
                            }).reverse()
                            .reduce(function(a,b){
                                if (a.slice(-1)[0] !== b) a.push(b); // slice(-1)[0] means last item in array without removing it (like .pop())
                                return a;
                        },[]); // this empty array becomes the starting value for a

                        let comparePrices = variants.map(variant => variant.compare_at_price);
                        comparePrices = comparePrices.slice() // slice makes copy of array before sorting it
                            .sort(function(a,b){
                                return parseInt(a) > parseInt(b);
                            }).reverse()
                            .reduce(function(a,b){
                                if (a.slice(-1)[0] !== b) a.push(b); // slice(-1)[0] means last item in array without removing it (like .pop())
                                return a;
                        },[]); // this empty array becomes the starting value for a
                        minPrice = prices[0];
                        maxPrice = prices[prices.length - 1];
                        compareAtPriceMin = comparePrices[0];
                    }
                }
                catch (err) {
                    console.error(err);
                }
            }

            if(parseInt(compareAtPriceMin) > parseInt(minPrice)) {
                priceHtml += `<span class="grid-product__price--original">${theme.Currency.formatMoney(compareAtPriceMin * 100, theme.moneyFormat)}</span>`;
            }

            if ( parseInt(maxPrice) > parseInt(minPrice) ) {
                priceHtml += 'from '
            }

            priceHtml += theme.Currency.formatMoney(minPrice * 100, theme.moneyFormat);

            currentGrid.querySelector('.grid-product__price .price-text').innerHTML = priceHtml;

            // remove active
            current.closest('.custom-swatch').querySelectorAll('li').forEach(li => {
                li.classList.remove('active')
            })

            // set active
            current.closest('li').classList.add('active')
        }
    }
})


// Engraving feature
class EngravingFeature extends HTMLElement {
    constructor(){
      super();

      this.modal = new theme.Modals('EngravingModal', 'engraving-popup-modal');
      this.textInput = document.getElementById('engraving-text');
      this.characterCountEl = this.querySelector('[data-current-count]');
      this.currentTargetSrc = this.querySelector('[data-engraving-target]');
      this.currentTarget = this.currentTargetSrc.dataset.engravingTarget;
      this.addToCartBtn = this.querySelector('.js-engraving-add-to-cart');
      this.productATCBtn = document.querySelector('[data-add-to-cart]');
      this.modalBtns = this.querySelectorAll('.js-modal-open-engraving-popup-modal');
      this.addTextBtn = this.querySelector('.js-add-character');
      this.addSymbolBtns = this.querySelectorAll('.engraving-symbols button');
      this.previewCharacters = this.querySelector('.engraving-characters');
      this.maxCharacters = this.previewCharacters.dataset.maxCharacters;
      this.currentCount = 0;
      this.errorMessageEl = this.querySelector('.error-message');
      this.fontSelectors = this.querySelectorAll('input[name="properties[engraving-font]"]');
      this.chosenFont = this.querySelector('input[name="properties[engraving-font]"]:checked').value;
      this.inputFrontEngraving = this.querySelector('input[data-front-engraving]');
      this.inputBackEngraving = this.querySelector('input[data-back-engraving]');
      this.isRingEngraving = this.dataset.isRing == "true";

      this.initEventListeners();
      this.updateFont(this.chosenFont);
    }

    initEventListeners() {
        this.textInput.addEventListener('keyup', (e) => {
            this.hideErroMessage();
        });

        this.fontSelectors.forEach(selector => {
            selector.addEventListener('change', (e) => {
                const chosenFont = e.target.value;
                this.chosenFont = chosenFont;
                this.updateFont(chosenFont);
            });
        })

        this.inputFrontEngraving.addEventListener('change', (e) => {
            if(e.target.value == '') {
                this.addToCartBtn.setAttribute('disabled', true);
            } else {
                this.addToCartBtn.removeAttribute('disabled');
            }
        })

        if(this.inputBackEngraving) {
            this.inputBackEngraving.addEventListener('change', (e) => {
                if(e.target.value == '') {
                    this.addToCartBtn.setAttribute('disabled', true);
                } else {
                    this.addToCartBtn.removeAttribute('disabled');
                }
            })
        }

        this.addTextBtn.addEventListener('click', () => {
            this.addText();
        });

        this.addSymbolBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                this.addSymbol(e);
            });
        });

        this.addToCartBtn.addEventListener('click', (e) => {
            this.addToCart(e);
        })

        if(this.modalBtns.length) {
            this.modalBtns.forEach(btn => {
                btn.addEventListener('click', (e) => {
                    const target = e.target.dataset.engraving;
                    this.currentTargetSrc.setAttribute('data-engraving-target', target);
                    this.currentTarget = target;
                    this.resetFields();
                })
            })
        }

        document.addEventListener('variant:change', (e) => {
            const isAvailable = e.detail.variant.available;
            this.updateAvailability(isAvailable);
        });

        $(document).on('click', '.js-remove-character', (e) => {
            this.removeCharacter(e);
        })
    }

    addText() {
        const text = this.textInput.value;
        if(text.length <= (this.maxCharacters - this.currentCount)) {
            this.textInput.value = "";
            this.updateCount(text.length);

            const textContainer = this.querySelector(`.engraving-text--${this.currentTarget}`);
            const propertiesInput = this.querySelector(`[data-${this.currentTarget}-engraving]`);
            const propertiesInputValue = propertiesInput.value;
            propertiesInput.value = propertiesInputValue + text;
            propertiesInput.dispatchEvent(new Event('change'));

            const textArray = text.split('');
            textArray.forEach(item => {
                const div = document.createElement('div');
                let itemHtml = `<span class="character">${item}</span><button type="button" class="js-remove-character" data-remove="${item}">X</button>`;
                div.innerHTML = itemHtml;
                this.previewCharacters.append(div);

                const span = document.createElement('span');
                span.classList.add('engraving-character-text');
                span.setAttribute('data-value', item);
                span.textContent = item;
                textContainer.append(span);
            })
            if(this.isRingEngraving) {
                this.updateTextCurve();
            }
        } else {
            this.errorMessageEl.textContent = "Too many characters";
            this.errorMessageEl.classList.remove('hide');
        }
    }

    addSymbol(e) {
        const symbol = e.target.dataset.symbol;
        if(this.currentCount < this.maxCharacters) {
            this.updateCount(1);
            const textContainer = this.querySelector(`.engraving-text--${this.currentTarget}`);
            const propertiesInput = this.querySelector(`[data-${this.currentTarget}-engraving]`);
            const currentValue = textContainer.innerHTML;
            const propertiesInputValue = propertiesInput.value;
            let symbolContext = '';
            if(e.target.dataset.symbolContext) {
                symbolContext = `${e.target.dataset.symbolContext}-`;
            }
            const symbolHTML = `<span class="symbol symbol-${symbolContext}${symbol}" data-value="[${symbol}]"></span>`;
            textContainer.innerHTML = currentValue + symbolHTML;
            propertiesInput.value = propertiesInputValue + '[' + symbol + ']';
            propertiesInput.dispatchEvent(new Event('change'));

            const div = document.createElement('div');
            let itemHtml = `<span class="character">${symbolHTML}</span><button type="button" class="js-remove-character" data-remove="[${symbol}]">X</button>`;
            div.innerHTML = itemHtml;
            this.previewCharacters.append(div);
            if(this.isRingEngraving) {
                this.updateTextCurve();
            }
        } else {
            this.errorMessageEl.textContent = "Character limit reached";
            this.errorMessageEl.classList.remove('hide');
        }
    }

    hideErroMessage() {
        this.errorMessageEl.textContent = "";
        this.errorMessageEl.classList.add('hide');
    }

    removeCharacter(e) {
        const self = e.target;
        const parent = self.closest('div');
        const mainParent = parent.parentNode;
        const index = Array.prototype.indexOf.call(mainParent.children, parent);
        const textToRemove = self.dataset.remove;    
        const engravingPreview = this.querySelector(`.engraving-text--${this.currentTarget}`);
        const propertiesInput = this.querySelector(`[data-${this.currentTarget}-engraving]`);

        engravingPreview.children[index].remove();
        propertiesInput.value = propertiesInput.value.replace(textToRemove, '');
        propertiesInput.dispatchEvent(new Event('change'));
        self.closest('div').remove();

        this.updateCount(-1);
        this.hideErroMessage();
        if(this.isRingEngraving) {
            this.updateTextCurve();
        }
    }

    updateCount(calc) {
        this.currentCount = this.currentCount + calc;
        this.textInput.setAttribute('maxlength', this.maxCharacters - this.currentCount);
        this.characterCountEl.textContent = this.currentCount;
    }

    updateFont(font) {
        if(font === "san serif") {
            font = "queensides";
        } else if (font === "bold") {
            font = "garlic";
        } else if (font === "cursive") {
            font = "brother-signature";
        }
        const engravingPreviews = this.querySelectorAll('.engraving-text');
        engravingPreviews.forEach(item => {
            item.classList.remove("queensides-font", "garlic-font", "brother-signature-font");
            item.classList.add(`${font}-font`);
        });
        this.previewCharacters.classList.remove("queensides-font", "garlic-font", "brother-signature-font"),
        this.previewCharacters.classList.add(`${font}-font`);
        if(this.isRingEngraving) {
            this.updateTextCurve();
        }
    }

    resetFields() {
        this.addToCartBtn.setAttribute('disabled', true);
        this.textInput.value = '';
        this.previewCharacters.innerHTML = '';
        this.updateCount(this.currentCount * -1);
        const engravingTextPreviews = this.querySelectorAll('.engraving-text');
        engravingTextPreviews.forEach(el => {
            el.innerHTML = '';
        });
        this.inputFrontEngraving.value = '';
        this.inputBackEngraving.value = '';
    }

    async addToCart(e) {
        const cartData = await fetchCart();
        const id = this.dataset.backEngravingId;
        const engravingFont = this.querySelector('input[name="properties[engraving-font]"]:checked').value;
        const engravingProduct = this.dataset.productName;
        const engravingProductId = this.dataset.productId;
        let engravingText = '';
        if(this.currentTarget == 'front') {
            engravingText = this.querySelector(`[data-front-engraving]`).value;
        } else {
            engravingText = this.querySelector(`[data-back-engraving]`).value;
        }

        let mainProductInCart = false;

        cartData.items.forEach(item => {
            if(item.product_id == engravingProductId) {
                mainProductInCart = true;
            }
        })
        let formData = {};
        formData['items'] = [{
            'id': id,
            'quantity': 1,
            'properties': {
                'engraving-location': this.currentTarget,
                'engraving-font': engravingFont,
                'engraving-text': engravingText,
                'engraving-product': engravingProduct,
                '_engraving-product-id': engravingProductId
            }
        }];
        if(!mainProductInCart) {
            const variantId = document.querySelector('[data-product-select]').value;
           formData['items'].unshift({
            'id': variantId,
            'quantity': 1
           }) 
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            this.modal.close();
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:open'));
            return response.json();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
        
    }

    updateAvailability(isAvailable) {
        const frontBtn = this.querySelector('.js-modal-open-engraving-popup-modal[data-engraving="front"]');
        const backBtn = this.querySelector('.js-modal-open-engraving-popup-modal[data-engraving="back"]');

        if(isAvailable) {
            if(frontBtn) {
                frontBtn.textContent = frontBtn.dataset.engravingText;
                frontBtn.removeAttribute('disabled');
            }
            if(backBtn) {
                backBtn.textContent = backBtn.dataset.engravingText;
                backBtn.removeAttribute('disabled');
            }
        } else {
            if(frontBtn) {
                frontBtn.textContent = "Sold Out";
                frontBtn.setAttribute('disabled', true);
            }
            if(backBtn) {
                backBtn.textContent = "Sold out";
                backBtn.setAttribute('disabled', true);
            }
        }
    }

    updateTextCurve() {
        const textSpans = this.querySelectorAll('.engraving-text span');
        const curveDirection = this.dataset.curveDirection;
        const curveRadius = this.dataset.curveRadius;

        let curveDirectionNumber = 1;
        if(curveDirection === "down") {
            curveDirectionNumber = -1;
        }

        // Majority of this was taken from this git repo https://github.com/peterhry/CircleType/tree/master - had to redo it as it broke the other engraving functionality and didn't work with the symbol font

        const getRect = (element) => {
            const rect = element.getBoundingClientRect();
            let { fontSize } = window.getComputedStyle(element);
            fontSize = parseFloat(fontSize);

            return {
              height: rect.height,
              left: rect.left + window.scrollX,
              top: rect.top + window.scrollY,
              width: rect.width,
              fontSize: fontSize
            };
        }

        const degreesPerRadian = 180 / Math.PI;

        const radiansToDegrees = (angleInRadians) => { 
            return angleInRadians * degreesPerRadian
        };

        const getLetterRotations = (metrics, r) => metrics.reduce((data, { width }) => {
            const rotation = radiansToDegrees(width / r);
          
            return {
              θ: data.θ + rotation,
              rotations: data.rotations.concat([ data.θ + (rotation / 2) ]),
            };
        }, { θ: 0, rotations: [] })

        if(textSpans.length) {
            let { fontSize, lineHeight } = window.getComputedStyle(textSpans[0]);
            fontSize = parseFloat(fontSize);
            lineHeight = parseFloat(lineHeight) || fontSize;
            let metrics = [];
            textSpans.forEach(el => {
                metrics.push(getRect(el));
            })
            const radius = curveRadius;
            const innerRadius = radius - lineHeight;
            const { rotations, θ } = getLetterRotations(metrics, innerRadius);
            textSpans.forEach((letter, index) => {
                const originY = curveDirectionNumber === -1 ? (-radius + lineHeight) : radius;
                const origin = `center ${originY / metrics[index].fontSize}em`;
                const { style } = letter;
                const rotate = ((θ * -0.5) + rotations[index]) * curveDirectionNumber;
                let translateX = (metrics[index].width * -0.5) / metrics[index].fontSize;
                const transform = `translateX(${translateX}em) rotate(${rotate}deg)`;
          
                style.position = 'absolute';
                style.bottom = curveDirectionNumber === -1 ? 0 : 'auto';
                style.left = '50%';
                style.transform = transform;
                style.transformOrigin = origin;
                style.webkitTransform = transform;
                style.webkitTransformOrigin = origin;
            })
    
        }
        
    }
    
}

customElements.define('engraving-feature', EngravingFeature);

// Check to remove additional engraving if the main engraving product is not in cart
document.addEventListener('cart:updated', (e) => {
    const cartItems = e.detail.cart.items;
    cartItems.forEach(item => {
        if(item.properties["_engraving-product-id"]) {
            checkMainEngravingProductInCart(cartItems, item.properties["_engraving-product-id"], item.key);
        }
    })
})

const checkMainEngravingProductInCart = async (cartItems, mainProductId, lineItem) => {
    let inCart = false
    cartItems.forEach(item => {
        if(item.product_id == mainProductId) {
            inCart = true;
        }
    });
    if(!inCart) {
        try {
            const res = await fetch(theme.routes.cartChange, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                method: "POST",
                body: JSON.stringify({
                    id: lineItem,
                    quantity: 0
                })
            });
            if (res.ok) {
                document.dispatchEvent(new CustomEvent('cart:build'));
            }
        } catch (error) {
            console.log({ error });
        }
    }
}


class GiftWrap extends HTMLElement {
    constructor(){
        super();

        this.button = this.querySelector('button');
        this.giftWrapProductId = this.button.dataset.giftWrapId;
        this.productId = this.button.dataset.productId;
        this.variantId = this.button.dataset.variantId;
        this.productName = this.button.dataset.productName;

        this.init()
    }

    init() {
        this.button.addEventListener('click', (e) => {
            this.addGiftWrap();
        });
    }

    addGiftWrap() {
        this.button.classList.add('btn--loading');
        let formData = {
            'items': [{
                'id': this.giftWrapProductId,
                'quantity': 1,
                'properties': {
                    'Gift Wrap Product': this.productName,
                    '_gift-wrap-product-id': this.productId,
                    '_gift-wrap-variant-id': this.variantId
                }
            }]
        };
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:open'));
            return response.json();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }
}

customElements.define('gift-wrap', GiftWrap);

// Check to remove gift wrapping product if main product is not in cart
document.addEventListener('cart:updated', (e) => {
    const cartItems = e.detail.cart.items;
    cartItems.forEach(item => {
        if(item.properties["_gift-wrap-product-id"]) {
            checkMainProductInCart(cartItems, item.properties["_gift-wrap-variant-id"], item.key);
        }
    })
})

const checkMainProductInCart = async (cartItems, mainVariantId, lineItem) => {
    let inCart = false
    cartItems.forEach(item => {
        if(item.id == mainVariantId) {
            inCart = true;
        }
    });
    if(!inCart) {
        try {
            const res = await fetch(theme.routes.cartChange, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                method: "POST",
                body: JSON.stringify({
                    id: lineItem,
                    quantity: 0
                })
            });
            if (res.ok) {
                document.dispatchEvent(new CustomEvent('cart:build'));
            }
        } catch (error) {
            console.log({ error });
        }
    }
}
